<template>
    <i-table size="small" border :columns="columns" :data="dataSource"></i-table>
</template>

<script>
export default {
    props: {
        data: Array
    },
    data() {
        return {
            columns: [
            {
                title: '不动产号',
                key: 'estateNO'
            },
            {
                title: '不动产单元号',
                key: 'estateUnitNO'
            },
            {
                title: '建造时间',
                key: 'buildTime'
            },
            {
                title: '楼号',
                key: 'buildingNO'
            },
            {
                title: '楼层',
                key: 'layer'
            },
            {
                title: '房屋号',
                key: 'houseNO'
            },
            {
                title: '结构',
                key: 'buildingStructure'
            },
            {
                title: '房屋属性',
                key: 'houseProperty'
            },
            {
                title: '状态',
                key: 'limitState'
            },
            {
                title: '规划使用',
                key: 'planningUse'
            },
            {
                title: '拥有权',
                key: 'possession'
            },
            {
                title: '地址',
                key: 'address'
            }],
            dataSource: []
        }
    },
    watch: {
        data: function(newVal){
            this.dataSource = newVal
        }
    }
}
</script>

<style lang="less" scoped>

</style>